var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 62,
    viewBox: "0 0 168 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_307_7693)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 160,
    height: 48,
    rx: 8,
    fill: "url(#paint0_linear_307_7693)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6301 31.288C76.1581 31.288 78.9901 29.416 80.4061 26.896V21.904H72.5821V25.456H76.2781V26.2C75.5101 27.088 74.3101 27.616 72.7981 27.616C69.9661 27.616 68.2381 25.768 68.2381 23.08C68.2381 20.464 69.8701 18.664 72.5581 18.664C74.3581 18.664 75.5821 19.48 76.5661 20.848L79.4461 18.4C77.9101 16.144 75.5581 14.872 72.6301 14.872C67.7581 14.872 64.0141 18.424 64.0141 23.08C64.0141 27.76 67.7821 31.288 72.6301 31.288ZM88.4478 31.288C92.1198 31.288 94.9998 28.504 94.9998 25C94.9998 21.496 92.1198 18.712 88.4478 18.712C84.7758 18.712 81.9198 21.472 81.9198 25C81.9198 28.528 84.7758 31.288 88.4478 31.288ZM88.4718 27.496C87.0798 27.496 86.1438 26.488 86.1438 25C86.1438 23.512 87.1038 22.504 88.4718 22.504C89.7918 22.504 90.7758 23.56 90.7758 25C90.7758 26.44 89.8158 27.496 88.4718 27.496ZM98.5619 24.664H101.922L102.69 15.16H97.7699L98.5619 24.664ZM100.29 31.288C101.826 31.288 102.954 30.112 102.954 28.6C102.954 27.112 101.826 25.912 100.29 25.912C98.6819 25.912 97.5539 27.112 97.5539 28.6C97.5539 30.112 98.6819 31.288 100.29 31.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.75,
    y: 0.75,
    width: 158.5,
    height: 46.5,
    rx: 7.25,
    stroke: "#282828",
    strokeWidth: 1.5,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_307_7693",
    x: 0,
    y: 0,
    width: 168,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_307_7693"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_307_7693",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_307_7693"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_307_7693",
    result: "effect3_innerShadow_307_7693"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_307_7693",
    x1: 84,
    y1: 0,
    x2: 84,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41E98B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AF4D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton);
export default __webpack_public_path__ + "static/media/button.c88c216c29456aad0a04b2a5740dbd94.svg";
export { ForwardRef as ReactComponent };